import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { Message } from 'ant-design-vue'
import jsCookie from 'js-cookie'
import '@/assets/styles/styles.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugin'
import lineClamp from 'vue-line-clamp'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://6d52523a383d4922bf3437b4557660aa@trap.cekid.com/36',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: '',    // --sentry release--
    whitelistUrls: [/haiziwang\.com/, /cekid\.com/]
  });

  Sentry.setUser({
    ...jsCookie.get(),
    id: `${jsCookie.get('buzzCode')}_${jsCookie.get('siteMobile')}_${jsCookie.get('id')}_${jsCookie.get('buzzId')}`,
    username: jsCookie.get('buzzCode') || jsCookie.get('siteMobile')
  })
}

Vue.config.productionTip = false
Vue.use(Message)
Vue.use(plugin)
Vue.use(lineClamp)

Vue.prototype.$message = Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
